module.exports = __webpack_public_path__ + "static/media/incentive.8d8c0021.svg";